export default "__VITE_ASSET__gF2tNH4c__"